import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";
import { CreateOrderWarrantyPayload } from "shared/api/middleware-api-client";

// Function to create a standard order payment link
const orderCreateWarranty = async (payload: CreateOrderWarrantyPayload) => {
  const res = await api().gersCreateOrderWarranty(payload);
  return res.data;
};

// Custom hook to handle the creation of a payment link for a standard product
export const useCreateOrderWarranty = () => {
  const { mutateAsync: addWarrantyToOrder, isLoading } = useMutation({
    mutationFn: (payload: CreateOrderWarrantyPayload) =>
      orderCreateWarranty(payload),
  });

  // Return the mutation function and loading state
  return {
    addWarrantyToOrder,
    isLoading,
  };
};
